import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

import styles from './TabsMenu.module.scss';

export type TabMenuItemType = {
  id: string;
  name: string;
};

type TabsMenuProps = {
  activeTabId: string;
  className?: string;
  list: TabMenuItemType[];
  onChange: (id: any) => void;
};

export const TabsMenu: React.FC<TabsMenuProps> = ({ className, activeTabId, list, onChange }) => {
  const listRef = useRef<HTMLUListElement>(null);
  const [indicatorPosition, setIndicatorPosition] = useState({ left: 0, width: 0 });

  useEffect(() => {
    if (listRef.current) {
      const activeItem = listRef.current.getElementsByClassName(styles.isActive)[0];
      const menuParams = listRef.current.getBoundingClientRect();
      if (activeItem) {
        const { width, left } = activeItem.getBoundingClientRect();
        const position = Math.round(left - menuParams.left); // position of indicator
        setIndicatorPosition({ left: position, width });
      }
    }
  }, [activeTabId]);

  return (
    <div className={clsx(styles.tabs, className)}>
      <ul ref={listRef}>
        {list.map(({ name, id }, index) => (
          <li
            key={`tab-menu-item-${id + index}`}
            className={clsx({ [styles.isActive]: id === activeTabId })}
            onClick={onChange.bind(null, id)}
          >
            {name}
          </li>
        ))}
      </ul>
      <div
        className={styles.indicator}
        style={indicatorPosition}
      />
    </div>
  );
};
